// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerChoices_root___u5OU"};